import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation,Autoplay,Pagination } from "swiper/modules";

const SwiperCarousel = ({ data, clickHandeler, cardPerview, slidePerClick, hasNextPrev, playInLoop }) => {
  return (
    <div className="custom-swiper">
    <Swiper
      modules={[Navigation,Autoplay,Pagination]}
      spaceBetween={20}
      slidesPerView={cardPerview}   // show 3 cards
      slidesPerGroup={slidePerClick}  // move 1 card per click ✅
      navigation={hasNextPrev}         // next/prev buttons
      loop={playInLoop}         // infinite loop
      breakpoints={{
        320: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      }}
      autoplay={{
        delay: 2000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true, // ✅ stops on hover
      }}
      pagination={{
        clickable: true, // ✅ click on dots
      }}
    >
      {data.map((item) => (
        <SwiperSlide key={item.id} onClick={clickHandeler} style={{cursor:'pointer'}}>
          <div className="m-2 mb-4 card-scrolling">
            <img src={item.src} height='auto' alt={item.alt} style={{ borderRadius: '1rem' }} />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
    </div>
  );
};

export default SwiperCarousel;